'use client';
import './styles/default.scss';
import { useStore } from '@/store/store';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { Spinner } from '@/app/elements/spinner';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { cleanupBodyScrollLock, lockBodyScroll, unlockBodyScroll } from '@/utils/scroll/scroll';

export const RouteLoadingSpinner = () => {
    const isLoading = useStore((s) => s.loading.isLoading);
    const pathname = usePathname();
    const scrollYRef = useRef(0);
    const wasLoadingRef = useRef(false);
    const pathnameWhenLoadingStartedRef = useRef<string | null>(null);

    useEffect(() => {
        if (isLoading) {
            pathnameWhenLoadingStartedRef.current = pathname;
            lockBodyScroll(scrollYRef);
            wasLoadingRef.current = true;
        } else if (wasLoadingRef.current) {
            const routeChanged =
                pathnameWhenLoadingStartedRef.current !== null && pathnameWhenLoadingStartedRef.current !== pathname;
            unlockBodyScroll(scrollYRef, {
                scrollToTop: routeChanged
            });
            pathnameWhenLoadingStartedRef.current = null;
            wasLoadingRef.current = false;
        }

        return () => {
            cleanupBodyScrollLock();
        };
    }, [isLoading, pathname]);

    return (
        isLoading && (
            <div className="route-loading-spinner">
                <Spinner />
            </div>
        )
    );
};
